
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/w/[symbol]",
      function () {
        return require("private-next-pages/[country]/w/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/w/[symbol]"])
      });
    }
  